
import React from "react";
import { useTheme } from "@material-ui/core";
import HvIconBase from "./IconBase";

const sizeSelector = (iconSize, height, width) => {
  if (height && width) {
    return { width, height };
  }

  switch (iconSize) {
    case "XS":
      return { width: 12, height: 12 };
    default:
    case "S":
      return { width: 16, height: 16 };
    case "M":
      return { width: 32, height: 32 };
    case "L":
      return { width: 96, height: 96 };
  }
};

const LineChartAlt = ({
  color,
  iconSize = "S",
  viewbox = "0 0 16 16",
  height,
  width,
  semantic,
  inverted = false,
  svgProps,
  ...others
}) => {
  const theme = useTheme();
  const getColor = c => theme.palette?.[c] || c;
  const colorArray = 
    (typeof color === "string" && [getColor(color)]) ||
    (Array.isArray(color) && color.map?.(getColor)) ||
    [theme.palette.acce1];

  if (semantic) {
    colorArray[0] = theme.palette?.[semantic] || colorArray[0];
  }

  if (inverted && colorArray[1]) {
    colorArray[1] = colorArray[0];
    colorArray[0] = "none";
  }

  const size = sizeSelector(iconSize, height, width);

  return (
    <HvIconBase name="LineChartAlt" iconSize={iconSize ?? "S"} {...others}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox={viewbox} height={size.height} width={size.width}   focusable={false} {...svgProps}>
  <path fill={colorArray[0]} className="color0"  d="M0 15h16v1H0zm10.139-3.397a1.5 1.5 0 001.353-2.147L13.748 7.2A1.5 1.5 0 1013 5.9a1.47505 1.47505 0 00.1.528l-2.315 2.314a1.555 1.555 0 00-1.294 0L7.274 6.526a1.5 1.5 0 10-2.716.042L2.3 8.825a1.5 1.5 0 00-2.3 1.27 1.50075 1.50075 0 102.924-.477l2.349-2.347a1.534 1.534 0 001.312-.022l2.2 2.2a1.5004 1.5004 0 001.354 2.146zm.5-1.508a.5.5 0 11-.5-.5.5.5 0 01.5.5zM1.5 9.594a.5.5 0 01.408.208l.00241.0034a.5.5 0 01-.12141.6966.493.493 0 01-.373.085.5.5 0 01-.416-.492H.999a.5.5 0 01.5-.5zm4.055-3.327a.5.5 0 11.708-.008.515.515 0 01-.707.009zM15 5.9a.5.5 0 11-.5-.5.5.5 0 01.5.5z" />
</svg>
    </HvIconBase>
)};

LineChartAlt.propTypes = HvIconBase.propTypes;

export default LineChartAlt;